<div [ngStyle]="{paddingTop: '0.1rem'}">
    <p-messages [key]="iBaseCRUModal?.overrideMessagesKey"></p-messages>
</div>
@if (!iBaseCRUModal || iBaseCRUModal.showLoading) {
    <div style="text-align: center" [ngStyle]="{minHeight: iBaseCRUModal?.contentMinHeight ?? '5rem'}">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration="1.5s"></p-progressSpinner>
        <div class="mt-2 mb-2">
            {{ iBaseCRUModal?.loadingStr ?? 'Initializing...' }}
        </div>
    </div>
}
<div
    [style.display]="!iBaseCRUModal?.showLoading ? 'block' : 'none'"
    [style.flex-grow]="'1'"
    [style.overflow-y]="'auto'"
>
    <div [ngClass]="contentClasses" [ngStyle]="{minHeight: iBaseCRUModal?.contentMinHeight, paddingTop: '0.5rem'}">
        <ng-content></ng-content>
    </div>
</div>
@if (showDefaultFormFooter && iBaseCRUModal && !iBaseCRUModal.showLoading) {
    <div class="p-dialog-footer">
        @if (showGoTo && !iBaseCRUModal.isCreationMode && iBaseCRUModal.goTo) {
            <p-button
                severity="secondary"
                icon="pi pi-external-link"
                type="button"
                label="Go to"
                (onClick)="iBaseCRUModal.goTo(); iBaseCRUModal.onCancel()"
            />
        }
        <p-button
            severity="contrast"
            icon="pi pi-times"
            type="button"
            [label]="
                iBaseCRUModal.dialogOpenMode === EDialogOpenMode.READ_ONLY ||
                iBaseCRUModal.dialogOpenMode === EDialogOpenMode.REVERT
                    ? 'Close'
                    : 'Cancel'
            "
            (onClick)="iBaseCRUModal.onCancel()"
        />
        @if (showPrevious) {
            <p-button
                severity="primary"
                icon="pi pi-chevron-left"
                type="button"
                label="Previous"
                (onClick)="iBaseCRUModal.onPrevious()"
                [disabled]="!previousEnabled"
            />
        }
        @if (showNext) {
            <p-button
                severity="primary"
                icon="pi pi-chevron-right"
                iconPos="right"
                type="button"
                label="Next"
                (onClick)="iBaseCRUModal.onNext()"
                [disabled]="!nextEnabled"
            />
        }
        @if (iBaseCRUModal.isCreationMode && showCreate) {
            <p-button
                severity="primary"
                icon="pi pi-check"
                type="submit"
                [label]="createButtonLabel"
                [disabled]="!iBaseCRUModal.canSubmit()"
                [title]="!iBaseCRUModal.canSubmit() ? 'Some field is invalid' : ''"
            />
        }
        @if (iBaseCRUModal.dialogOpenMode === EDialogOpenMode.EDIT) {
            <p-button
                icon="pi pi-check"
                type="submit"
                [label]="updateButtonLabel"
                [disabled]="!iBaseCRUModal.canSubmit()"
                [title]="iBaseCRUModal.canSubmit() ? 'Some field is invalid' : ''"
            />
        }
        @if (iBaseCRUModal.dialogOpenMode === EDialogOpenMode.REVERT) {
            <p-button
                icon="pi pi-history"
                type="submit"
                label="Revert"
                [disabled]="!iBaseCRUModal.canSubmit()"
                [title]="
                    !(iBaseCRUModal ? iBaseCRUModal.canSubmit() : false)
                        ? 'This value is already the current value'
                        : ''
                "
            />
        }
    </div>
}
